'use client';

import * as React from 'react';

/**
 * Variant for the chat message display layout.
 * - `'default'`: Standard layout with avatar, content, and message meta
 * - `'compact'`: Condensed layout with reduced spacing
 */
import { jsx as _jsx } from "react/jsx-runtime";
const ChatVariantContext = /*#__PURE__*/React.createContext('default');

/**
 * Provides the chat variant to all descendant message components.
 * Controls how messages are laid out without prop drilling.
 * @example
 * <ChatVariantProvider variant="compact">
 *   <ChatMessageList />
 * </ChatVariantProvider>
 */
if (process.env.NODE_ENV !== "production") ChatVariantContext.displayName = "ChatVariantContext";
export function ChatVariantProvider(props) {
  const {
    children,
    variant
  } = props;
  return /*#__PURE__*/_jsx(ChatVariantContext.Provider, {
    value: variant,
    children: children
  });
}

/**
 * Returns the current chat variant from the nearest {@link ChatVariantProvider}.
 * Consumed by `MessageRoot` and `MessageGroup` to apply layout-specific ownerState.
 */
export function useChatVariant() {
  return React.useContext(ChatVariantContext);
}